import { mapMutations } from "vuex";
import { memberLogin, patientsCallBack } from "@/api";
const mixin = {
    methods: {
        ...mapMutations({
            afterLogin: "user/afterLogin",
        }),
        login(memberId, merchantCode, merchantAccessToken) {
            return new Promise((resolve, reject) => {
                let SALT = merchantAccessToken;
                let time = new Date().getTime();
                let rawSign = `company_code=${merchantCode}&member_id=${memberId}&time=${time}${SALT}`;
                let companyCode = merchantCode;

                if (merchantAccessToken == undefined || merchantAccessToken == null || merchantAccessToken.length < 3) {
                    console.log('进来旧版登陆');
                    SALT = "ecd8da6fe560f7d42a673f19e0ccb238";
                    time = new Date().getTime();
                    rawSign = `company_code=iMeddy&member_id=${memberId}&time=${time}${SALT}`;
                    companyCode = 'iMeddy';

                    if (this.$route.query.loginType) {
                        SALT = "022d0a8e6f7a5f9d4dee62d5dca77aac";
                        companyCode = 'HK_GYT'
                        rawSign = `company_code=HK_GYT&member_id=${memberId}&time=${time}${SALT}`;
                    }
                    if (this.$route.query.loginTypeKy) {
                        SALT = this.$route.query.getAccountToken;
                        companyCode = 'HK_KY';
                        rawSign = `company_code=HK_KY&member_id=${memberId}&time=${time}${SALT}`;
                    }
                    if (this.$route.query.loginTypeYy) {
                        SALT = this.$route.query.getAccountToken;
                        companyCode = 'HK_IMDOCTOR';
                        rawSign = `company_code=HK_IMDOCTOR&member_id=${memberId}&time=${time}${SALT}`;
                    }
                }


                let sha1 = require("sha1");
                let sign = sha1(rawSign).toUpperCase();
                let data = {
                    company_code: companyCode,
                    member_id: memberId,
                    time: time,
                    sign,
                };
                console.log(JSON.stringify(data))
                memberLogin(data)
                    .then((loginRes) => {
                        let userInfo = localStorage.getItem("userInfo");
                        if (!userInfo || loginRes.data.userId != JSON.parse(userInfo).userId) {
                            this.$message({
                                type: "success",
                                message: "登錄成功！",
                            });
                        }
                        this.afterLogin(loginRes.data);
                        resolve(loginRes);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
    },
};
export default mixin;
